<template>
  <div v-cloak>
    <p><strong>Attached Files</strong></p>
    <ul v-if="files.length > 0" class="list-group mb-4">
      <li v-for="file in files" class="list-group-item">
        <button v-on:click="removeFile(file.id)" type="button" class="mr-2 btn btn-sm btn-danger"><i
            class="fa fa-trash"></i></button>
        <a :href="`https://platform.openai.com/storage/files/${file.id}`"
                                   target="_blank">{{ file.filename }}</a>
      </li>
    </ul>
    <p v-else class="alert alert-info">No files attached</p>
    <file-pond
        ref="pond"
        :server="pondServer"
        accepted-file-types="application/pdf, text/plain, text/csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        label-idle="Drop files here or <span class='filepond--label-action'>Browse</span>"
        name="file"
        v-bind:allow-multiple="false"
        @processfile="handleFileSuccess"
        @processfileerror="handleFileFailure"
    />
  </div>
</template>

<script>
import vueFilePond from 'vue-filepond'
import 'filepond/dist/filepond.min.css'
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'

const FilePond = vueFilePond(FilePondPluginFileValidateType)

export default {
  props: ['vector', 'filesp'],
  components: {
    FilePond
  },
  data() {
    return {
      files: [],
      pondServer: {
        process: {
          url: `/vector-stores/${this.vector}/upload`,
          headers: {
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
          }
        }
      }
    }
  },
  computed: {},
  methods: {
    handleFileSuccess(error, response) {
      if (error) {
        console.error('Failed to upload file', error)
        return
      }
      console.log(JSON.parse(response.serverId))
      let resp = JSON.parse(response.serverId)
      this.files.push({
        id: resp.id,
        filename: resp.id
      })
    },
    handleFileFailure(error, file) {
      console.error('Failed to upload file', error)
    },
    removeFile: async function (id) {
      let resp = await fetch(`/vector-stores/${this.vector}/file/${id}`, {
        method: 'DELETE',
        headers: {
          'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        }
      })
      if (resp.status === 200) {
        this.files = this.files.filter((item) => item.id !== id)
      } else {
        alert('An Error Occurred')
      }
      resp = await resp.json()
      console.log(resp)
    }
  },
  mounted() {
    this.files = JSON.parse(this.filesp)
    console.log(this.files)
  }
}
</script>